module.exports = __webpack_public_path__ + "static/img/zhpic.d9d3e1a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/zhpic.gif
// module id = Wirp
// module chunks = 1